import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@web-frontend/shared/services/toast/toast.service';
import { BackendError } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private i18n: TranslateService,
    private toastService: ToastService
  ) {}

  handleBackendErrors(error: HttpErrorResponse): void {
    const errorMessage = this.getBackendErrorMessage(error);
    if (!errorMessage) return;

    this.toastService.show({
      msDuration: 4000,
      type: 'error',
      text: errorMessage,
    });
  }

  getBackendErrorMessage(error: HttpErrorResponse): string | null {
    const backendError = error.error as BackendError | undefined;

    if (!backendError || !backendError.code) {
      return null;
    }

    let errorMessage = this.i18n.instant(`backendErrors.${backendError.code}`);

    if (errorMessage === `backendErrors.${backendError.code}`) {
      errorMessage = this.i18n.instant('backendErrors.genericError');
    }

    return errorMessage;
  }
}
